import React, {useState, useEffect } from 'react'
import AppLayout from './AppLayout'
import { NavLink } from 'react-router-dom'
import { useParams } from 'react-router-dom'




import projectServices from '../../app/admin/erp/project/projectServices';
import { useAlert } from '../../context/AlertContext';
import ProjectForm from '../../app/admin/erp/project/components/ProjectForm';
import { useAppData } from '../../context/AppDataContext';




function ProjectLayout({children}) {
    const {id} = useParams();
    const {AppAlert} = useAlert();

    const {companyLocationDD,partyDD,userDD,getDDDataById} = useAppData();

    const [expandDetails,setExpanDetails] = useState(false)
    const [projectDetails,setProjectDetails] = useState(null);

    
    

    const getProjectDetails = () =>{
        projectServices.getById(id).then(res=>{
            setProjectDetails(res.data);
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }


    useEffect(()=>{
        getProjectDetails();
    },[id])
    


    return (
        
        <AppLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-2'>
                        

                        <div className="list-group">
                            <NavLink to={"/project/details/"+id} className="list-group-item list-group-item-action">Project Details</NavLink>
                            <NavLink to={"/project/task/"+id} className="list-group-item list-group-item-action">Project Task</NavLink>
                            <NavLink to={"/project/team-list/"+id} className="list-group-item list-group-item-action">Project Team</NavLink>
                            <NavLink to={"/project/target-list/"+id} className="list-group-item list-group-item-action">Project Targets</NavLink>
                        </div>


                        {projectDetails &&
                            <div className='card mt-3'>
                                <div className='card-header bg-dark text-white fw-bold' onClick={()=>setExpanDetails(!expandDetails)}  >{projectDetails.title} <span className='float-end'><ProjectForm  callBack={getProjectDetails} data={projectDetails} /></span></div>
                                {expandDetails &&
                                    <div className='card-body' >
                                        <div style={{whiteSpace:"pre-line"}}>{projectDetails.details}</div>
                                    </div>
                                }
                                {expandDetails &&
                                    <div className='card-footer' >
                                        <div><span className='fw-bold'>Project Location : </span>{getDDDataById(companyLocationDD,projectDetails.projectLocationId).label}</div>
                                        <div><span className='fw-bold'>Customer : </span>{getDDDataById(partyDD,projectDetails.customerId).label}</div>
                                        <div><span className='fw-bold'>Project Manager : </span>{getDDDataById(userDD,projectDetails.managerId).label}</div>
                                        <div><span className='fw-bold'>Created By : </span>{getDDDataById(userDD,projectDetails.userId).label}</div>
                                    </div>
                                }
                            </div>
                        }

                        
                        
                    </div>
                    <div className='col-md-10'>
                        {children}
                    </div>
                </div>
            </div>
        </AppLayout>
    )
}

export default ProjectLayout